<form [formGroup]="form">
    <p-multiSelect
        #select
        class="w-full"
        styleClass="w-full"
        [options]="options"
        optionLabel="name"
        formControlName="marketingTouches"
        appendTo="body"
        [filter]="true"
        display="chip"
        filterBy="name"
        (onChange)="valueChange()"
        (onBlur)="onInputBlur()"
        [virtualScroll]="virtualScroll()"
        [virtualScrollItemSize]="virtualScrollItemSize()"
        [resetFilterOnHide]="true"
        [autofocusFilter]="true"
    >
        <ng-template pTemplate="selectedItems">
            <div class="p-dropdown-label-empty" *ngIf="!value || value.length === 0">empty</div>
            <p-tag *ngFor="let option of value">
                {{option.name}}
                <fa-icon class="p-tag-icon-right" [icon]="icons.solid.faCircleXmark" (click)="removeItem(option)"></fa-icon>
            </p-tag>
        </ng-template>
    </p-multiSelect>
</form>